// extracted by mini-css-extract-plugin
module.exports = {"intro":"manufacturer-intro-module--intro--JY6iH","title":"manufacturer-intro-module--title--1rNqA","bodyText":"manufacturer-intro-module--bodyText--1IfaO"};